// extracted by mini-css-extract-plugin
export default {"anchor":"TileAnchor-module__anchor--FKV2K"};